import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import jwt_decode from "jwt-decode";
import { httpPost } from "../../utils/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Google({ closeModal }) {
  const navigate = useNavigate();
  const { REACT_APP_BASE_URL } = process.env;

  const callGoogle = async (token) => {
    try {
      let decoded = jwt_decode(token);

      const data = {
        email: decoded.email,
        googleId: decoded.sub,
      };

      const res = await httpPost(
        `${REACT_APP_BASE_URL}/auth/google`,
        data
      );

      if (res?.data?.status) {
        localStorage.setItem("goldsmith_token", res?.data?.token);
        localStorage.setItem(
          "userData",
          JSON.stringify(res?.data?.response)
        );

        toast.success(res?.data?.message || "Login Successful ✅");

        navigate("/account");

        if (closeModal) closeModal();
      } else {
        toast.error(res?.data?.message || "Google login failed ❌");
      }
    } catch (error) {
      console.error(error);
      toast.error("Email already exists in database ❌");
    }
  };

  return (
    <GoogleLogin
      onSuccess={(credentialResponse) => {
        callGoogle(credentialResponse.credential);
      }}
      onError={() => {
        toast.error("Google Sign In Error ❌");
      }}
    />
  );
}

export default Google;
